export default __webpack_public_path__ + "static/media/running_man.491659d7.png";